import { Box, Flex, Spinner, Text } from "@chakra-ui/react";
import { keyframes } from "@emotion/react";
import { useIsAnyStripePaymentSettling } from "../utils/stripePaymentSettlingStore";

const pulse = keyframes`
  0%, 100% { opacity: 1; }
  50% { opacity: 0.78; }
`;

/**
 * Banner shown while the SPA is polling for fulfillment after a Stripe-hosted
 * Checkout return. Pinned to the top of the viewport with full-bleed styling
 * so users can't miss it — the previous bottom-right toast variant was easy
 * to overlook, and stale "Buy"/"Subscribe" CTAs underneath misled users into
 * thinking the purchase hadn't gone through.
 */
export function StripePaymentSettlingBanner() {
  const isSettling = useIsAnyStripePaymentSettling();

  if (!isSettling) return null;

  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      right={0}
      zIndex="banner"
      bg="blaze.blaze"
      color="dune.dune"
      boxShadow="0px 4px 24px 0px rgba(0, 0, 0, 0.40)"
      borderBottom="1px solid"
      borderColor="blaze.700"
      role="status"
      aria-live="polite"
      animation={`${pulse} 1.6s ease-in-out infinite`}
    >
      <Flex
        align="center"
        justify="center"
        gap="3"
        px={{ base: "16px", md: "24px" }}
        py={{ base: "12px", md: "14px" }}
        maxWidth="1200px"
        marginX="auto"
      >
        <Spinner size="md" color="white" thickness="3px" />
        <Text
          fontSize={{ base: "14px", md: "16px" }}
          fontWeight="600"
          lineHeight="130%"
        >
          Confirming your purchase — please don't close this tab.
        </Text>
      </Flex>
    </Box>
  );
}
